<template>
  <BaseEditModal
    displayName="Channel Import Failed!"
    helpFileName="ChannelImportResult"
    icon="mdi-play-speed"
    :masterObj="{}"
    :tabs="tabs"
    @close="emit('close')"
    :hideTabs="true"
    hideBottomButtons
    :customState="results"></BaseEditModal>
</template>
<script setup>
import BaseEditModal from '@/components/Shared/Modals/BaseEditModal.vue';
import ChannelImportResultTab from './ChannelImportResultTab.vue';
const props = defineProps(['results']);
const emit = defineEmits(['close', 'locked']);

const tabs = [
  {
    id: 0,
    title: 'Failure Report',
    icon: 'mdi-rename-box',
    display: true,
    component: ChannelImportResultTab,
  },
];
</script>
<style scoped></style>
